import { render, staticRenderFns } from "./PainelVisualizacaoView.vue?vue&type=template&id=0a45547e&scoped=true"
import script from "./PainelVisualizacaoView.vue?vue&type=script&lang=js"
export * from "./PainelVisualizacaoView.vue?vue&type=script&lang=js"
import style0 from "./PainelVisualizacaoView.vue?vue&type=style&index=0&id=0a45547e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45547e",
  null
  
)

export default component.exports